import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgStarsMagic = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-stars-magic';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M17.26 3.868c-.353.807-.553 1.22-.671 1.386-.126.18-.422.344-1.381.767-.539.238-.871.405-.84.423.029.016.43.195.892.398s.935.429 1.05.503c.28.179.402.379.848 1.395.203.462.383.864.4.894.019.035.149-.217.361-.7.434-.988.624-1.352.772-1.477.156-.131.485-.296 1.348-.675.382-.168.721-.32.752-.338q.058-.03-.697-.363c-1.012-.445-1.267-.576-1.423-.733-.167-.167-.338-.496-.732-1.408a15 15 0 0 0-.339-.752c-.015-.017-.168.289-.34.68m-5.998.336-.422 1.214c-.459 1.326-.716 1.948-1.163 2.818-.627 1.221-1.075 1.762-1.925 2.325-.511.339-1.546.867-2.272 1.16-.314.127-2.189.793-2.717.965-.031.01.428.186 1.02.392 1.402.485 1.923.694 2.797 1.124 1.694.831 2.323 1.442 3.135 3.046.411.811.65 1.387 1.044 2.515l.43 1.23.103.293.408-1.173c.485-1.395.68-1.879 1.103-2.739.395-.8.871-1.527 1.25-1.906.37-.37.972-.77 1.772-1.177.859-.437 1.474-.69 2.796-1.15a44 44 0 0 0 1.17-.417c.029-.016-.467-.208-1.131-.438-1.352-.468-1.997-.731-2.82-1.148-1.558-.79-2.149-1.374-2.936-2.901-.427-.828-.718-1.536-1.184-2.877a48 48 0 0 0-.424-1.196c-.008-.008-.023.01-.034.04m.967 5.856c.651.98 1.453 1.653 2.805 2.353l.573.297-.59.307c-1.764.918-2.51 1.668-3.455 3.471l-.272.519-.258-.494c-.748-1.43-1.389-2.203-2.362-2.847a14 14 0 0 0-1.497-.855l-.217-.099.248-.117a11.4 11.4 0 0 0 2.049-1.274c.589-.474 1.202-1.303 1.742-2.356l.294-.574.298.574c.163.316.452.809.642 1.095"
    })
  }));
});
export default SvgStarsMagic;